import styled, { css } from 'styled-components';

import { media } from '@theme/media';
import { ArtworkArtist as Name } from '@components/artworkCard/artworkCard.styles';

import { Item, List } from '../grid.styles';

export const GridList = styled(List)`
  ${media.tablet} {
    margin: 0 70px;
  }
`;

export const GridWrapper = styled.div`
  padding: 0 5px;
  width: auto;
  max-width: 40%;
  min-width: 30%;

  ${media.mobile} {
    padding: 0;
    width: unset;
    max-width: unset;
    min-width: unset;
  }
`;

export const GridItem = styled(Item)`
  width: auto;
  padding: 0 5px 0;

  ${media.tablet} {
    padding: 0 10px 0;
  }
`;

export const ArtworkArtist = styled(Name)`
  display: none;

  ${media.desktop} {
    display: block;
  }
`;

export const imageStyles = css`
  height: 90px;
  object-fit: contain;
  max-width: 100%;

  ${media.tablet} {
    height: 250px;
    max-width: 500px;
  }
`;
